import React, { Component } from 'react'
import { observer } from 'mobx-react'
import store from '../../../store'
import style from '@common/ModalIf/style.module.less'
import { Link } from 'react-router'
import { SHOP_PRODUCTS_PATH } from '@constant'

@observer
export default class extends Component {
  render() {
    const {
      modalIf: { type, isShow, btn1, btn2, content }
    } = store
    return (
      <div>
        {isShow ? (
          <div className={style.tipBox} style={{ zIndex: 999 }}>
            <div className={style.tip2}>
              <div className={style.cont}>{content}</div>
              <div className={style.btnBox}>
                {type == 1 && <button onClick={store.onCancel}>{btn1}</button>}
                {type == 2 && (
                  <span>
                    <button onClick={store.onCancel}>{btn1}</button>
                    <button>
                      <Link to={SHOP_PRODUCTS_PATH}>{btn2}</Link>
                    </button>
                  </span>
                )}
              </div>
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    )
  }
}
